<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="pt_code,pt_pjcode,pj_dename,pt_task"
      placeholder="输入单号、项目名称进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/plm/problem_task/' + item.id"
      >
        <div class="weui-cell__bd">
          <p>{{ item.pt_code }}</p>
          <p class="list-item-muted">{{ item.pj_dename }}&nbsp;{{ item.pj_emname }}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{ item.pt_task }} &nbsp;{{ item.pt_emname }}</p>
          <span
            class="list-item-status"
            :class="{ warning: item.pt_status != '已审核' }"
            >{{ item.pt_status }}</span
          >
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{ items.length }}单</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/plm/problemtask/list",
      filters: [
        {
          type: "date",
          name: "plm_problem_task.createTime",
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
            },
            {
              value: 1,
              label: "待审核",
              condition: "pt_status='未审核'",
            },
            {
              value: 2,
              label: "已提交",
              condition: "pt_status='已提交'",
            },
          ],
        },
      ],
    };
  },
};
</script>